// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FPg5N","content":"styles_content__3oMo6"};